export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-768w.d1e80f01.avif";